<template>
    <v-container fluid class="ma-0 pa-0 login-bg">
        <forgotPasswordSVG :class="[this.$vuetify.breakpoint.smAndDown ? 'loginSVG-mobile' : 'loginSVG']"
                           :rectColor="loginSVGColors.rectColor"
                           :stopColor1="loginSVGColors.stopColor1"
                           :stopColor2="loginSVGColors.stopColor2"
                           :stopColor3="loginSVGColors.stopColor3"
                           :circleColor1="loginSVGColors.circleColor1"
                           :circleColor2="loginSVGColors.circleColor2">

        </forgotPasswordSVG>
        <v-row>
            <v-toolbar flat>
                <v-hover v-slot="{hover}">
                    <v-btn @click="toggleLocale" class="text-none text-normal" text absolute right plain :color="hover ? 'linkHover' : 'primary'">{{$t('forgot-password.locale')}}</v-btn>
                </v-hover>
            </v-toolbar>
        </v-row>
        <v-row>
            <v-col>
                <v-row align="center" justify="center" :class="isMobile ? [] : ['py-16', 'mt-16']">
                    <v-col align="center">
                        <v-card class="my-auto rounded-xl"
                                :class="isMobile ? ['pt-4'] : ['pt-8']"
                                max-width="500px"
                                flat>
                            <v-img class="mx-auto px-5 login-logo"
                                   :src="`../../assets/Branding/${this.$experience.key}/Images/${getLogo}`"
                                   max-width="270px"
                                   contain>
                            </v-img>

                            <v-card-subtitle class="text-center card-title">{{$t('forgot-password.title')}}</v-card-subtitle>
                            <v-card-text class="pb-0">
                                <v-row>
                                    <v-col class="pa-0 pt-5" :class="[ this.$vuetify.breakpoint.smAndDown ? 'mx-9' : 'mx-10' ]">
                                        <v-alert v-if="this.errorMsg" dense dark type="error">{{$t(this.errorMsg)}}</v-alert>
                                        <v-form ref="step1Form" v-model="step1Valid" @submit.prevent="onNext" lazy-validation>
                                            <v-text-field v-model="ForgotPasswordViewModel.userName"
                                                          :placeholder="$t('forgot-password.username')"
                                                          outlined
                                                          hide-details
                                                          maxlength="50"
                                                          class="mb-1 text-normal min-height-1"
                                                          :rules="usernameRules"
                                                          prepend-inner-icon="mdi-account-outline"></v-text-field>
                                        </v-form>
                                        <v-row class="mb-2">
                                            <v-hover v-slot="{hover}">
                                                <v-btn class="text-none text-small min-height-1" type="submit" text plain
                                                       :color="hover ? (loginLinkHoverColor ? loginLinkHoverColor : 'linkHover') : (loginLinkColor ? loginLinkColor : 'primary')"
                                                       to="/login">{{$t('forgot-password.returnToLogin')}}</v-btn>
                                            </v-hover>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions class="mx-8">
                                <v-hover v-slot="{hover}">
                                    <v-btn block
                                           :disabled="isFormProcessing"
                                           depressed
                                           :dark="!isFormProcessing"
                                           class="text-none mb-8 text-normal min-height-1"
                                           :color="hover ? 'buttonHover' : 'primary'"
                                           @click="onNext">
                                        {{$t('forgot-password.send')}}
                                        &nbsp;
                                        <v-progress-circular v-if="isFormProcessing" indeterminate
                                                             color="primary">
                                        </v-progress-circular>
                                    </v-btn>
                                </v-hover>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog v-model="emailSentConfirmation" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="#74DF13"
                            class="my-5">mdi-check-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ $t('forgot-password.title') }}</v-card-subtitle>
                <v-card-subtitle class="text-center card-subtitle2 font-weight-medium mt-1">{{ $t('forgot-password.EmailSent') }}</v-card-subtitle>
                <v-card-actions>
                    <v-row justify="center">
                        <v-btn class="text-normal" depressed color="primary" x-large @click="onEmailSentConfirmation">{{$t('ok')}}</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { apiService } from "../../services";
    import { mapState, mapActions } from "vuex";
    import forgotPasswordSVG from '../../components/forgotPasswordSVG.vue';

    export default {
        name: "forgotPassword",
        components: { forgotPasswordSVG },
        data() {
            return {
                ForgotPasswordViewModel: {
                    userId: "",
                    userName: "",
                    emailAddress: "",
                    exp: ""
                },
                step: 1,
                step1Valid: true,
                errorMsg: "",
                requiredRules: [
                    v => !!v || this.$t('forgot-password.fieldRequired')
                ],
                usernameRules: [
                    v => !!v || this.$t('forgot-password.fieldRequired'),
                    v => (v && String(v).toLowerCase().match(/[^\w@.À-ú-]/gs) == null),
                    v => (v && v.length <= 50) || this.textLengthRule('username', 50)
                ],
                logo: "",
                formProcess: false,
                emailSentConfirmation: false
            }
        },
        computed: {
            ...mapState("account", ["status", "user"]),

            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            formMaxWidth() {
                if (this.step === 2) return "600px";
                return "375px";
            },
            loginSVGColors() {
                return this.$vuetify.theme.themes.light.loginSVG;
            },
            isFormProcessing() {
                return this.formProcess;
            },
            loginLinkHoverColor() {
                return this.$experience.loginLinkHoverColor;
            },

            loginLinkColor() {
                return this.$experience.loginLinkColor;
            },
            getLogo() {
                return (this.$i18n.locale == 'en' && this.$experience.logoLoginEN != null) ? this.$experience.logoLoginEN : this.$experience.logo;
            },

        },
        created() {
            this.logout();
        },
        mounted() {
            let unsubscribe = null
            unsubscribe = this.$store.subscribe(({ type }) => {
                if (type === 'account/loginSuccess') {
                    unsubscribe() // So it only reacts once.
                }
            })
        },
        methods: {
            ...mapActions("account", ["logout"]),
            toggleLocale() {
                this.$emit("toggleLocale");
            },
            fieldRequired(val) {
                return this.$t('forgot-password.fieldRequired', { field: this.$t(val) });
            },
            onNext() {
                this.errorMsg = "";
                this.$refs.step1Form.validate();
                if (this.step1Valid) {
                    this.formProcess = true;

                    apiService.forgotPassword(this.ForgotPasswordViewModel)
                        .then((response) => {
                            this.formProcess = false;
                            if (response.data.success) {
                                this.emailSentConfirmation = true;
                                localStorage.setItem("user", null);
                            }
                        })
                        .catch((error) => {
                            this.formProcess = false;
                            this.errorMsg = error;
                        })
                }
                
            },
            onEmailSentConfirmation() {
                this.sentEmailConfirmation = false;
                this.$router.push("login");
            },
            textLengthRule(fieldName, n) {
                return this.$t('forgot-password.textLengthRule', { field: this.$t(fieldName), n: n })
            }
        },
    }

</script>

<style scoped>

    .login-logo {
        margin-top: 50px !important;
        margin-bottom: 50px !important;
    }

    .loginSVG {
        position: absolute;
        top: 50%;
        width: 100%;
        height: 50%;
    }

    .loginSVG-mobile {
        position: absolute;
        top: 48px;
        width: 100%;
        height: 50%;
    }
</style>

